export default __webpack_public_path__ + "static/media/balance-bike.c74fd55e.glb";